import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("界面渲染异常", error, info);
  }

  private reset = (): void => {
    this.setState({ error: null });
  };

  render(): ReactNode {
    if (!this.state.error) return this.props.children;

    return (
      <main className="fatal-error" role="alert">
        <h1>页面暂时无法显示</h1>
        <p>请重试；若问题持续，请联系系统管理员并提供发生时间。</p>
        <button type="button" onClick={this.reset}>
          重试
        </button>
      </main>
    );
  }
}
